import * as React from "react";
import { ReadingLevelSearchForm } from "../../ReadingLevelSearchForm";
import { LS2PacSearchDatabaseManager } from "@tlc/ls2pac/app/managers/SearchDatabaseManager";
import { LS2PAC_CONSTANTS } from "src/main/resources/js/main/constants";
import { TLCEventManager } from "../../../events/EventManager";
import { AdvancedSearchEvent } from "../../BooleanSearchForm";
import { LoaderFunctionArgs, redirect } from "react-router";
import { LocationConfigurationHolder } from "../../LocationConfiguration";

export async function readingLevelLoader({ request }: LoaderFunctionArgs) {
  console.log("readingLevelLoader executing");

  const { pacSettings } =
    await LocationConfigurationHolder.fetchLocationConfiguration();

  if (!pacSettings.acceleratedReaderEnabled && !pacSettings.lexileEnabled) {
    return redirect("/advanced-search/boolean");
  }

  return {};
}

export const ReadingLevelSearchPage: React.FC = () => {
  const handleAdvancedSearchEvent = (event: AdvancedSearchEvent) => {
    const db = LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.ls2pac.key
    LS2PacSearchDatabaseManager.setCurrentDatabaseKey(
      db
    );
    TLCEventManager.fireEvent(
      LS2PAC_CONSTANTS.Events.onFireAdvancedSearch,
      {...event, databaseKey: db}
    );
  };

  return (
    <ReadingLevelSearchForm
      onClickSearch={handleAdvancedSearchEvent}
    ></ReadingLevelSearchForm>
  );
};
